import { useSelector } from "react-redux";

import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { selectCompetitiveResultsFilters } from "../../store/selectors";
import { CompetitiveCategoryFilter } from "../CompetitiveCategoryFilter/CompetitiveCategoryFilter";
import { CompetitiveIndustryTaxonomyFilter } from "../CompetitiveIndustryTaxonomyFilter/CompetitiveIndustryTaxonomyFilter";
import { CompetitiveSiteFilter } from "../CompetitiveSiteFilter/CompetitiveSiteFilter";

import { StyledLabel, StyledCompetitiveFilter, StyledCompetitiveFilterInner } from "./styles";

export const CompetitiveFilter = () => {
    // The response carries exactly one of the two classifications, so it — not the opt-in setting —
    // is what decides which control renders (ADR-0013).
    const { category, industryTaxonomy } = useSelector(selectCompetitiveResultsFilters);

    const onClearAll = () => {
        proNavigator.updateParams({
            similarsites_filters: null,
        });
    };

    return (
        <StyledCompetitiveFilter>
            <StyledCompetitiveFilterInner>
                <StyledLabel>{translate("traffic.search.phrases.page.filterby.title")}</StyledLabel>
                <CompetitiveSiteFilter />
                {industryTaxonomy?.length ? (
                    <CompetitiveIndustryTaxonomyFilter nodes={industryTaxonomy} />
                ) : category?.length ? (
                    <CompetitiveCategoryFilter categories={category} />
                ) : null}
            </StyledCompetitiveFilterInner>
            <Button
                type="flat"
                onClick={onClearAll}
            >
                {translate("forms.buttons.clearall.text")}
            </Button>
        </StyledCompetitiveFilter>
    );
};
